// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__pE8ZK","image":"Avatar_image__hMtyr","default":"Avatar_default__GEU6u","link":"Avatar_link__zhftg"};